import { TThunkAction } from '../../types/redux';
import { setNextStep, setPrevStep } from './stepActionsTypes';
import { addReviewActions } from './addReviewActions';
import { selectIsCurrentStepValid } from '../../selectors/newReview';
import { selectIsLastContentStep } from '../../selectors/newReview/selectIsLastContentStep';

export function goToNextStep(): TThunkAction<void> {
  return (dispatch, getState) => {
    const state = getState();

    const isCurrentStepValid = selectIsCurrentStepValid(state);
    if (!isCurrentStepValid) {
      return;
    }

    const isLastContentStep = selectIsLastContentStep(state);
    if (isLastContentStep) {
      dispatch(addReviewActions());

      return;
    }

    dispatch(setNextStep());
  };
}

export function goToPrevStep(): TThunkAction<void> {
  return dispatch => {
    dispatch(setPrevStep());
  };
}
